import { Send } from "@mui/icons-material";
import styled from "styled-components";
import { mobile,tablet } from "../responsive";
import { useState } from "react";

const Container = styled.div`
  background-color: #fcf5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding:10px;
`;
const Title = styled.h1`
  font-size: 70px;
  margin-bottom: 20px;
  ${tablet({fontSize:"50px"})}
  ${mobile({fontSize:"40px"})}

  
`;

const Desc = styled.div`
  font-size: 24px;
  font-weight: 300;
  margin-bottom: 20px;
  ${tablet({fontSize:"20px"})}
  ${mobile({ textAlign: "center" ,fontSize:"16px"})}

`;

const InputContainer = styled.div`
  width: 50%;
  height: 40px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgray;
  ${mobile({ width: "80%" })}
`;

const Input = styled.input`
  border: none;
  flex: 8;
  padding-left: 20px;
`;

const Button = styled.button`
  flex: 1;
  border: none;
  background-color: teal;
  color: white;
`;
const Newsletter = () => {
const [email,setEmail]=useState('');

  return (
    <Container>
      <Title>Newsletter</Title>
      <Desc>Get timely updates from your favorite products.</Desc>
      <InputContainer>
        <Input placeholder="Your email" value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
        <Button onClick={()=>{
          console.log(email);
          setEmail('')}
          }>
          <Send />
        </Button>
      </InputContainer>
    </Container>
  );
};

export default Newsletter;
